module.exports = __webpack_public_path__ + "travel_summer-pop_1.jpg";